var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-filter"},[_c('r-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.tabs),function(tab){return _c('r-tab',{key:tab.id,attrs:{"id":tab.id,"name":tab.title}})}),1),_c(_vm.active,_vm._b({tag:"component",on:{"load":_vm.prepareData}},'component',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }